// checks if a version in format ex. 1.44.5345 is less than the required version
export function isVersionLessThan(version, requiredVersion) {
    // if either version or requiredVersion is null or undefined, return false
    if (!version || !requiredVersion) {
        return false
    }

    const versionDots = (version.match(/\./g) || []).length
    const requiredVersionDots = (requiredVersion.match(/\./g) || []).length

    if (versionDots === requiredVersionDots) {
        // remove all non-numeric characters except the decimal point from the strings
        let v1parts = version.split(".").map(Number)
        let v2parts = requiredVersion.split(".").map(Number)

        // pad the shorter array with zeros
        while (v1parts.length < v2parts.length) v1parts.push(0)
        while (v2parts.length < v1parts.length) v2parts.push(0)

        for (let i = 0; i < v1parts.length; ++i) {
            if (v1parts[i] < v2parts[i]) {
                return true
            } else if (v1parts[i] > v2parts[i]) {
                return false
            }
        }

        // the versions are identical
        return false
    } else {
        // fallback, remove all non-numeric characters and the decimal point from the strings
        version = parseFloat(version.replace(/[^0-9]/g, ""))
        requiredVersion = parseFloat(requiredVersion.replace(/[^0-9]/g, ""))

        return version < requiredVersion
    }
}

export function formatMeasureProgramList(value, type) {
    if (value === null) return "0";
    if (value === 'n/a') return value;
    if (value && value > -1) {
      if (
        type === 'total_duration_time' ||
        type === 'rating_over_time_percent' ||
        type ==='reach_over_time_percent'
      ){     
          let replaceToComma =  value.toString().replace('.', ',');
          return replaceToComma
      }
        
      else if(type === 'relative_contacts'){
          let numberToFixed = value.toFixed(3);           
          let replaceToComma =  numberToFixed.toString().replace('.', ',');
          return replaceToComma;
      }
    }
    return formatNumberWithThousandSeparator(value);
}
export function formatMeasureCampaignList(number, measureType) {
    if (number === null) return "0";
    if (number === 'n/a') return number;
    if (measureType === 'completion_rate') {
      return number ? `${(number * 100).toFixed(2)}%`.toString().replace('.', ',') : "0,00%";
    } else if (
          measureType === 'trp' ||
          measureType === 'reach_over_time_percent'
     ) {
          return number ? number.toFixed(2).toString().replace('.', ',') : "0,00"
    } else if (measureType === 'total_duration_time')
      return number ? number.toFixed(3).toString().replace('.', ',') : "0,000"
    return formatNumberWithThousandSeparator(Math.round(number).toString().replace('.', ','));
}
export function formatMeasureSiteList(number, measureType) {
  if (number === null) return "0";
  if (number === 'n/a') return number;
      if (
        measureType === 'total_duration_time_content' ||
        measureType === 'reach_over_time_percent_content' ||
        measureType === 'total_duration_time_all' ||
        measureType === 'reach_over_time_percent_all'
      )
      {
        number = number ? number.toFixed(3).toString().replace('.', ',') : "0,000";
        return number
      }
      return formatNumberWithThousandSeparator(Math.round(number)).toString().replace('.', ',');
}
export function formatNumberWithThousandSeparator(number) {
    if (number === null) return;
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

